var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridCenteredWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 748 633",
    style: {
      enableBackground: "new 0 0 748 633"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 88.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -140.3,
    className: "st0",
    width: 748,
    height: 93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -139.8,
    className: "st1",
    width: 747.1,
    height: 92
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(368 74.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -368,
    y: 242.3,
    className: "st0",
    width: 748,
    height: 93
  }), /*#__PURE__*/React.createElement("rect", {
    x: -367.5,
    y: 242.8,
    className: "st1",
    width: 747.1,
    height: 92
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(184 167.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -184,
    y: -35,
    className: "st0",
    width: 748,
    height: 93
  }), /*#__PURE__*/React.createElement("rect", {
    x: -183.5,
    y: -34.5,
    className: "st1",
    width: 746.9,
    height: 92
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(552 167.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -552,
    y: 333,
    className: "st0",
    width: 748,
    height: 93
  }), /*#__PURE__*/React.createElement("rect", {
    x: -551.5,
    y: 333.5,
    className: "st1",
    width: 746.9,
    height: 92
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(92 167.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -92,
    y: -127,
    className: "st0",
    width: 748,
    height: 93
  }), /*#__PURE__*/React.createElement("rect", {
    x: -91.5,
    y: -126.5,
    className: "st1",
    width: 746.9,
    height: 92
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(460 61.832)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -460,
    y: 346.7,
    className: "st0",
    width: 748,
    height: 93
  }), /*#__PURE__*/React.createElement("rect", {
    x: -459.6,
    y: 347.2,
    className: "st1",
    width: 747.2,
    height: 92
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(276 74.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -276,
    y: 150.3,
    className: "st0",
    width: 748,
    height: 93
  }), /*#__PURE__*/React.createElement("rect", {
    x: -275.6,
    y: 150.8,
    className: "st1",
    width: 747.1,
    height: 92
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(644)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -644,
    y: 592.5,
    className: "st0",
    width: 748,
    height: 93
  }), /*#__PURE__*/React.createElement("rect", {
    x: -643.6,
    y: 593,
    className: "st1",
    width: 747.2,
    height: 92
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 149)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: -149,
    className: "st0",
    width: 104.6,
    height: 633
  }), /*#__PURE__*/React.createElement("rect", {
    x: -39.8,
    y: -148.5,
    className: "st1",
    width: 103.6,
    height: 632
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(413.709 66)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: -66,
    className: "st0",
    width: 104.6,
    height: 633
  }), /*#__PURE__*/React.createElement("rect", {
    x: -39.8,
    y: -65.6,
    className: "st1",
    width: 103.6,
    height: 632.1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.855 149)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: -149,
    className: "st0",
    width: 104.6,
    height: 633
  }), /*#__PURE__*/React.createElement("rect", {
    x: -39.8,
    y: -148.5,
    className: "st1",
    width: 103.6,
    height: 632
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(620.564 149)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: -149,
    className: "st0",
    width: 104.6,
    height: 633
  }), /*#__PURE__*/React.createElement("rect", {
    x: -39.8,
    y: -148.5,
    className: "st1",
    width: 103.6,
    height: 632
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.427 149)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: -149,
    className: "st0",
    width: 104.6,
    height: 633
  }), /*#__PURE__*/React.createElement("rect", {
    x: -39.8,
    y: -148.5,
    className: "st1",
    width: 103.6,
    height: 632
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(517.137 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: -55,
    className: "st0",
    width: 104.6,
    height: 633
  }), /*#__PURE__*/React.createElement("rect", {
    x: -39.8,
    y: -54.6,
    className: "st1",
    width: 103.6,
    height: 632.2
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(310.282 66)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: -66,
    className: "st0",
    width: 104.6,
    height: 633
  }), /*#__PURE__*/React.createElement("rect", {
    x: -39.8,
    y: -65.6,
    className: "st1",
    width: 103.6,
    height: 632.2
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(723.992)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    className: "st0",
    width: 104.6,
    height: 633
  }), /*#__PURE__*/React.createElement("rect", {
    x: -39.8,
    y: 0.4,
    className: "st1",
    width: 103.6,
    height: 632.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridCenteredWhite);
export default __webpack_public_path__ + "static/media/grid-centered-white.a3db97e0f415cee13a5578d952eb68c2.svg";
export { ForwardRef as ReactComponent };